import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { SharedModule } from "../../shared.module";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';

@Component({
  selector: 'app-privilege',
  standalone: false,
  templateUrl: './privilege.component.html',
  styleUrl: './privilege.component.scss'
})
export class PrivilegeComponent implements OnInit, OnDestroy {
  cols: any[] = [
    // { field: 'dragg', header: '' },
    { field: 'name', header: 'Name', filterType: 'text' },
    { field: 'code', header: 'Code', filterType: 'text' },
    { field: 'description', header: 'Description', filterType: 'text' },
  ];
  userData: any[] = [];
  privilegeForm: FormGroup
  tableTitle = 'Privilege';
  showAddDialog: boolean = false;
  showEditDialog: boolean = false;
  showDeleteDialog: boolean = false;
  selectedObj: any;
 private mySubscription= new Subscription();

  constructor(private api: ApiService, private messageService: MessageService, private fb: FormBuilder , private permissionService: PermissionsService) { }

  ngOnInit(): void {
    this.getPrivilege();
    this.privilegeForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      code: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      description: ['', Validators.required],
      status: [1]
    });
  }

  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }
   totalRecords: number = 0;
  getPrivilege(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/access/privileges/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
 const sub =   this.api.getAPI(url).subscribe((res: any) => {
      this.userData = res.results;
       this.totalRecords = res.count || 0

    });
      this.mySubscription.add(sub)
  }
  addPrivilege() {
    this.privilegeForm.reset()
    this.privilegeForm.enable()
    this.showAddDialog = true;
  }
  submitAddForm() {
    if (this.privilegeForm.valid) {
      const payload = {
        name: this.privilegeForm.get('name')?.value,
        description: this.privilegeForm.get('description')?.value,
        code: this.privilegeForm.get('code')?.value,
        status: 1
      };

      const sub = this.api.postAPI('/access/privileges/', payload).subscribe({
        next: (res: any) => {
          if (res) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'New privilege added'
            });

            // Add new privilege to the list
            this.userData = [...this.userData, res];
            this.getPrivilege()
            // Reset form and close dialog
            this.privilegeForm.reset();
            this.showAddDialog = false;
            this.selectedObj = null; // Optional: clear selection
          }
        },
        error: (err) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error',
          //   detail: 'Failed to add privilege'
          // });
          console.error('Add privilege error:', err);
        }
      });
      this.mySubscription.add(sub)
    }
  }
  viewMode = false;
viewSystem(rowData: any) {
  this.viewMode = true;
   if (rowData && rowData.id) {
      this.selectedObj = rowData;
      this.showEditDialog = true
      this.privilegeForm.patchValue({
        name: rowData.name || '',
        code: rowData.code || '',
        description: rowData.description || '',
      });
      this.privilegeForm.disable()
    }
}
  updatePrivilege(e: any) {
    this.showEditDialog = true;
    this.viewMode = false;
    this.privilegeForm.enable()
    this.selectedObj = e
    this.privilegeForm.patchValue({
      name: e.name,
      description: e.description,
      code: e.code,
      status: 1
    })
  }
  submitEditForm() {
    const sub = this.api.putAPI(`/access/privileges/${this.selectedObj.id}/`, this.privilegeForm.value).subscribe({
      next: (res: any) => {
        if (res) {
          // Update the existing object in userData
          this.userData = this.userData.map(item =>
            item.id === this.selectedObj.id ? res : item
          );

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Privilege updated'
          });
          this.getPrivilege()

          this.showEditDialog = false;
          this.privilegeForm.reset();
          this.selectedObj = null;
        }
      },
      error: (err) => {
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to update privilege'
        // });
        console.error('Update error:', err);
      }
    });
    this.mySubscription.add(sub)
  }

  deletePrivilege(e: any) {
    this.showDeleteDialog = true;
    this.selectedObj = e
  }
  confirmDelete() {
    const sub = this.api.deleteAPI(`/access/privileges/${this.selectedObj.id}/`).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Privilege deleted'
        });
        this.showDeleteDialog = false
        this.getPrivilege()
        // Remove the deleted item from userData
        this.userData = this.userData.filter(item => item.id !== this.selectedObj.id);
        this.selectedObj = null;
      },
      error: (err) => {
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete privilege'
        // });
        console.error('Delete error:', err);
      }
    });
    this.mySubscription.add(sub)
  }
      get canEditSetup(): boolean {
  return this.permissionService.hasPrivilege('/setup', 'View') ||
         this.permissionService.hasPrivilege('/setup', 'Edit') ||
         this.permissionService.hasPrivilege('/setup', 'Delete');
}
}
